import { CUSTOMER_TYPE, PAYMENT_METHOD, RECIPIENT_TYPES } from 'components/common/constants';

export default function CreateTemplateModel(data) {
  const requestData = {
    templateName: data?.templateName,
    amount: data?.amount,
    currency: data?.currency,
    paymentMethod: data?.paymentMethod
  };

  // Add paymentPurpose as 'paymentPurpose' for UAE bank country
  if (data?.bankCountry === 'AE' && data?.paymentPurpose) {
    requestData.paymentPurpose = data.paymentPurpose;
  }

  const requisites = {};
  if (
    [PAYMENT_METHOD.SEPA, PAYMENT_METHOD.SEPA_INSTANT, PAYMENT_METHOD.SWIFT].includes(data?.paymentMethod) &&
    data?.accountNumber
  ) {
    requisites.iban = data?.accountNumber;
  }

  if (
    [
      PAYMENT_METHOD.FASTER_PAYMENTS,
      PAYMENT_METHOD.BACS,
      PAYMENT_METHOD.CHAPS,
      PAYMENT_METHOD.SWIFT,
      PAYMENT_METHOD.INTERNAL
    ].includes(data?.paymentMethod) &&
    data?.accountNumber
  ) {
    requisites.accountNumber = data?.accountNumber;
    requisites.iban = data?.iban;
    requisites.cryptoAddress = data?.cryptoAddress;
    requisites.cryptoNetwork = data?.cryptoNetwork;
  }

  if (
    [PAYMENT_METHOD.FASTER_PAYMENTS, PAYMENT_METHOD.BACS, PAYMENT_METHOD.CHAPS].includes(data?.paymentMethod) &&
    data?.sortCode
  )
    requisites.sortCode = data?.sortCode;
  if (data.paymentMethod === PAYMENT_METHOD.SWIFT && data?.bankCountry) requisites.bankCountry = data?.bankCountry;
  if (data.paymentMethod === PAYMENT_METHOD.SWIFT && data?.bankName) requisites.bankName = data?.bankName;
  if (data.paymentMethod === PAYMENT_METHOD.SWIFT && data?.bic) requisites.bic = data?.bic;
  if (data.paymentMethod === PAYMENT_METHOD.CRYPTO && data?.accountNumber)
    requisites.cryptoAddress = data?.accountNumber;
  if (data.paymentMethod === PAYMENT_METHOD.CRYPTO && data?.network) requisites.cryptoNetwork = data?.network;

  const beneficiary = {
    type: data?.type || CUSTOMER_TYPE[data?.recipientType?.toUpperCase()]?.toUpperCase(),
    registrationNumber: data?.registrationNumber,
    city: data?.city,
    country: data?.country,
    postCode: data?.postCode,
    address: data?.address
  };
  if (data?.recipientType === RECIPIENT_TYPES.COMPANY && data?.companyName) beneficiary.companyName = data?.companyName;
  if (data?.recipientType === RECIPIENT_TYPES.INDIVIDUAL && data?.firstName) beneficiary.firstName = data?.firstName;
  if (data?.recipientType === RECIPIENT_TYPES.INDIVIDUAL && data?.lastName) beneficiary.lastName = data?.lastName;

  if (data?.isCryptoPayment) {
    requestData.beneficiary = {
      type: RECIPIENT_TYPES.INDIVIDUAL.toUpperCase(),
      firstName: 'Friendly',
      lastName: 'Recipient'
    };
  } else {
    requestData.comment = data?.transferDetails;
    requestData.beneficiary = beneficiary;
  }

  requestData.requisites = requisites;

  return requestData;
}
